import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import { auth } from '../../firebase/index';
import classes from './Auth.module.css';

const Auth = ({ isAdmin }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (isAdmin) {
            navigate('/', { replace: true });
        }
    }, [isAdmin, navigate]);

    const signInWithGoogle = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.signInWithPopup(provider).catch(err => console.error('Sign-in error:', err));
    };

    if (isAdmin) return null;

    return (
        <div className={classes.Auth}>
            <h2>Kirjaudu sisään</h2>
            <button onClick={signInWithGoogle}>Kirjaudu Google-tilillä</button>
        </div>
    );
};

const mapStateToProps = state => ({
    isAdmin: state.auth.isAdmin
});

export default connect(mapStateToProps)(Auth);
